import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { listPopup } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxPopupProps extends PartProps<ComponentProps<typeof Combobox.Popup>> {
  className?: string
}

function ComboboxPopup({ className, children, ...props }: ComboboxPopupProps) {
  return (
    <Combobox.Popup
      className={twMerge(
        listPopup,
        'pointer-events-auto z-50 max-h-[min(var(--available-height),23rem)] w-[var(--anchor-width)] max-w-[var(--available-width)] scroll-py-1',
        className,
      )}
      {...props}
    >
      {children}
    </Combobox.Popup>
  )
}

export { ComboboxPopup }
